import { Connector, configureChains, createClient } from "wagmi";
import { jsonRpcProvider } from "wagmi/providers/jsonRpc";
// import { getBNBChains } from '../bnb';
import { getBNBconfig } from "../bnb";
import { getWallets } from "../helper/helper";
import { bsc } from "wagmi/chains";
import { WalletData } from "../../types/common";

const buildClient: any = (
  network: string,
  providerKey: string,
  wallets: Array<WalletData>,
  isNativeChain?: boolean
) => {
  // eslint-disable-next-line no-console
  console.log(isNativeChain);
  const config = getBNBconfig(network);

  const { chains, provider } = configureChains(
    [bsc],
    [
      jsonRpcProvider?.({
        rpc: () => ({
          http: `${config.rpcUrls.default}/${providerKey}`,
        }),
      }),
    ]
  );

  const wagmiClient = createClient({
    autoConnect: true,
    connectors: getWallets(wallets, chains) as unknown as Connector<
      any,
      any,
      any
    >[],
    provider,
  });

  return { wagmiClient, config };
};

export default buildClient;
